import React from 'react';

const DownloadImage: React.FC<{ width?: string; height?: string; fill?: string }> = ({
  width = '24px',
  height = '24px',
  fill = '#F1F1F1',
}): React.ReactElement => {
  return (
    <>
      <svg
        width={width}
        height={height}
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M22.5 1.5V22.5H1.5V1.5H22.5ZM21 3H3V15.4393L7.5 10.9393L10.6687 14.1081L14.2506 10.1281L21 17.6449V3ZM21 19.8901L14.2485 12.372L8.05747 19.2517L6.94253 18.2483L9.66385 15.2246L7.5 13.0613L3 17.5607V21H21V19.8901ZM20.25 6.75C20.25 5.09315 18.9069 3.75 17.25 3.75C15.5931 3.75 14.25 5.09315 14.25 6.75C14.25 8.40685 15.5931 9.75 17.25 9.75C18.9069 9.75 20.25 8.40685 20.25 6.75ZM15.75 6.75C15.75 5.92157 16.4216 5.25 17.25 5.25C18.0784 5.25 18.75 5.92157 18.75 6.75C18.75 7.57843 18.0784 8.25 17.25 8.25C16.4216 8.25 15.75 7.57843 15.75 6.75Z"
          fill={fill}
        />
      </svg>
    </>
  );
};

export default DownloadImage;
